import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { StaffCard } from '../../../../components';
import { i18n } from '../../../../language';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '1.875rem',
  },
  title: {
    width: '13.438rem',
    height: '2.813rem',
    padding: '0.688rem 1.438rem 0.625rem 1.25rem',
    borderRadius: '0.5rem',
    backgroundColor: '#4073d2',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    letterSpacing: '0',
    color: theme.palette.font.white,
    fontWeight: '600',
    marginBottom: '0.563rem',
  },
  body: {
    width: '100%',
  },
  head: {
    marginBottom: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.5rem',
    letterSpacing: 0,
    color: theme.palette.font.main,
    fontWeight: '500',
  },
}));

export default function DutyIC({ list, setDutyICList, publishCtrl, head, handleEdit, enableSmartComm }) {
  const classes = useStyles();

  const handleInputChange = (index, value) => {
    setDutyICList((pro) => {
      pro[index].dutyStaffs[0].name = value;
      return [...pro];
    });
  };

  return (
    <div className={classes.root}>
      {head.length > 0 && <div className={classes.head}>{head}</div>}
      <Box display="flex" flexWrap="wrap">
        {list.map((item, index) => (
          <Box mr="1.188rem" key={item.id}>
            <div className={classes.title}>{item.title}</div>
            <StaffCard
              name={item.dutyStaffs[0].name ?? ''}
              Width="13.438rem"
              remark={item.dutyStaffs[0].remark}
              longremark={item.dutyStaffs[0].longremark}
              outlineColour={index + 1}
              publishCtrl={publishCtrl}
              staff={true}
              setDutyICList={setDutyICList}
              handleInputChange={(value) => {
                handleInputChange(index, value);
                handleEdit(false);
              }}
              dutyICIndex={index}
              dutyICPlaceholder={i18n.t('DUTYASSIGN_DUTYIC_PLACEHOLDER', { value: item.title })}
              dutyIC={true}
              {...item}
              enableSmartComm={enableSmartComm}
            />
          </Box>
        ))}
      </Box>
    </div>
  );
}
